import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "width", "title"];
import React from 'react';
import Svg from '../Svg';

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 6C8.27614 6 8.5 6.24421 8.5 6.54545L8.5 9.27273C8.5 9.57397 8.27614 9.81818 8 9.81818C7.72386 9.81818 7.5 9.57397 7.5 9.27273L7.5 6.54545C7.5 6.24421 7.72386 6 8 6Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 11.5C8.5 11.8012 8.27614 12 8 12C7.72386 12 7.5 11.8012 7.5 11.5C7.5 11.1988 7.72386 11 8 11C8.27614 11 8.5 11.1988 8.5 11.5Z",
  fill: "white"
});

var ErrorLineSmall = function ErrorLineSmall(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#4C5165' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1.6rem' : _ref$width,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Error icon' : _ref$title,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Svg, _extends({
    title: title,
    width: width,
    viewBox: "0 0 16 16",
    fill: "none"
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M6.97645 1.58371C7.4312 0.80543 8.56881 0.805429 9.02355 1.58371L15.8401 13.2502C16.2946 14.028 15.7261 15 14.8166 15H1.18343C0.27395 15 -0.294602 14.028 0.159886 13.2502L6.97645 1.58371Z",
    fill: color
  }), _ref2, _ref3);
};

export default ErrorLineSmall;